/*
 * Copyright (c) 2022. Nedaware SL
 */

import {Component, Inject} from "@angular/core";
import {EditionListDialogComponent} from "./edition-list-dialog.component";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {BaseDialogData} from "../../basic-entity-front/basic-entity-table/base-dialog-data";
import {UntypedFormBuilder} from "@angular/forms";
import {EntityNameService} from "../../basic-entity-back/services/entity-name.service";
import {InterfaceProviderService} from "../../basic-entity-back/services/interface-provider.service";
import {Municipio} from "../../model/localizacion/municipio.model";
import {Pais} from "../../model/localizacion/pais.model";
import {Comunidad} from "../../model/localizacion/comunidad.model";
import {Provincia} from "../../model/localizacion/provincia.model";
import {SimpleDialogService} from "../../basic-entity-front/dialog-shell/simple-dialog.service";
import {ErrorDisplayService} from "../../basic-entity-front/services/error-display.service";
import {ApiModuleFactory} from "../../api/api-module-factory.service";

@Component({
    selector: 'app-festivo-edition',
    templateUrl: './edition-list-dialog.component.html',
    styleUrls: ['./edition-list-dialog.component.scss']
})
export class FestivoEditionComponent extends EditionListDialogComponent<any> {
    constructor(
        @Inject(MAT_DIALOG_DATA) data: BaseDialogData<any>,
        dialogRef: MatDialogRef<FestivoEditionComponent>,
        apiService: ApiModuleFactory,
        fb: UntypedFormBuilder,
        nameProvider: EntityNameService,
        interfaceProvider: InterfaceProviderService,
        confirmationDialog: SimpleDialogService,
        errorDisplay: ErrorDisplayService
    ) {
        super(
            'festivos',
            [
                {name: 'Países', property: 'festivos', model: Pais},
                {name: 'Comunidades', property: 'festivosPropios', model: Comunidad},
                {name: 'Provincias', property: 'festivosPropios', model: Provincia},
                {name: 'Municipios', property: 'festivosPropios', model: Municipio}
            ],
            data, dialogRef, apiService, fb, nameProvider, confirmationDialog, interfaceProvider, errorDisplay);
    }
}
